import { Link } from 'react-router-dom';
import { Block, ErrorNote, Loading, Row, Screen, TwoCol } from '../components/primitives';
import { ChartFigures, ChartReadings } from '../components/panels/chart';
import { apiErrorPayload } from '../lib/api';
import { chartMoonLine, chartTitle } from '../lib/format';
import { useChart, useFeatureLocked } from '../lib/queries';
import { ProLock } from '../components/pro-lock';

export function ChartPage() {
  const locked = useFeatureLocked('chart');
  const chart = useChart();

  if (locked) {
    return (
      <Screen back="/align" eyebrow="Your birth chart" title="Your chart is part of Pro">
        <ProLock feature="chart" />
      </Screen>
    );
  }
  if (chart.isPending) return <Loading label="Casting your chart" />;
  if (chart.isError) {
    if (apiErrorPayload(chart.error)?.error === 'birth_details_required') {
      return (
        <Screen back="/align" eyebrow="Your birth chart" title="Add your birth details">
          <Block
            action={
              <Link to="/settings" className="eyebrow underline underline-offset-4 hover:text-ink">
                Go to settings
              </Link>
            }
          >
            Your chart is calculated from your birth date, time and place.
          </Block>
        </Screen>
      );
    }
    return <ErrorNote error={chart.error} retry={() => void chart.refetch()} />;
  }

  // Wide, with the figures beside their reading: stacked, the prose sits a full
  // screen below the square it explains.
  return (
    <Screen
      wide
      back="/align"
      eyebrow="Your birth chart"
      title={chartTitle(chart.data)}
      subtitle={chartMoonLine(chart.data)}
    >
      <TwoCol
        split="1/1"
        left={<ChartFigures data={chart.data} />}
        right={<ChartReadings data={chart.data} />}
      />
      <Row
        title="The words in your reading"
        meta="What a dasha, a nakshatra and a yoga are"
        to="/align/learn"
      />
    </Screen>
  );
}
